/** Sui framework package id on DGC (same as 0x2). */
export const CPC_FRAMEWORK = '0x0000000000000000000000000000000000000000000000000000000000000002';
/** Native coin type: `0x2::rwax::RWAX`. */
export const RWAX_TYPE = `${CPC_FRAMEWORK}::rwax::RWAX`;
/** @deprecated use RWAX_TYPE */
export const DGC_TYPE = RWAX_TYPE;
/** @deprecated use RWAX_TYPE — this is native gas, not app CPC. */
export const CPC_TYPE = RWAX_TYPE;
/**
 * Published app coin `{pkg}::cpc::CPC` (50M, not native RWAX).
 * Override via `clob-market-presets.json` `cpcTypeTag` after republish.
 */
export const DEFAULT_APP_CPC_TYPE = '0x5b7ef2b4b610d61867aa068ad6a8dcc84408e359a1df776668486b12146bf76f::cpc::CPC';
/**
 * Mainnet DATA type tag (CLOB quote / bridge asset). Override via `VITE_CPC_DATA_COIN_TYPE`
 * or pass `dataTypeTag` into lock builders.
 */
export const DEFAULT_DATA_TYPE = '0xae64a956cff6d3b32e31c38c1fd3465aa1ed9966b2ff2cc2c307694a40042b8d::data::DATA';
export const MIST_PER_RWAX = 1000000000n;
/** @deprecated use MIST_PER_RWAX */
export const MIST_PER_DGC = MIST_PER_RWAX;
/** @deprecated use MIST_PER_RWAX */
export const MIST_PER_CPC = MIST_PER_RWAX;
export const DEFAULT_CPC_RPC_URL = 'https://rpc.rwaxs.com';
